<template>
  <v-card flat>
    <v-card-text class="pt-6">
      <ValidationObserver ref="observer">
        <v-form ref="form" :readonly="loadingFormProfile">
          <ValidationProvider name="Nama" rules="required" v-slot="{ errors }">
            <v-text-field
              dense
              outlined
              label="Nama"
              color="light-green"
              v-model="form.account_name"
              :error-messages="formErrors.account_name || errors"
            >
            </v-text-field>
          </ValidationProvider>
          <ValidationProvider
            name="Telepon"
            rules="required|min:8|max:13"
            v-slot="{ errors }"
          >
            <v-text-field
              dense
              outlined
              type="number"
              label="Telepon"
              color="light-green"
              v-model="form.account_mobilephone"
              :error-messages="formErrors.account_mobilephone || errors"
            >
            </v-text-field>
          </ValidationProvider>
          <ValidationProvider name="Email" rules="email" v-slot="{ errors }">
            <v-text-field
              dense
              outlined
              label="Email"
              color="light-green"
              v-model="form.account_email"
              :error-messages="formErrors.account_email || errors"
            >
            </v-text-field>
          </ValidationProvider>
        </v-form>
      </ValidationObserver>
      <v-alert v-if="error.message" text type="error" class="custom-alert my-4">
        <p class="body-2 mb-0">
          {{ error.message }}
        </p>
      </v-alert>
    </v-card-text>
    <v-card-actions class="pb-6 px-6">
      <v-spacer></v-spacer>
      <v-btn
        color="light-green"
        dark
        elevation="0"
        :disabled="loadingFormProfile"
        :loading="loadingFormProfile"
        @click="save"
        class="text-capitalize"
      >
        Simpan
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import profile from '@/mixins/profile';
export default {
  mixins: [profile],
  data() {
    return {
      form: {
        account_name: '',
        account_mobilephone: '',
        account_email: ''
      }
    };
  },
  computed: mapState(['user']),
  created() {
    this.form = {
      account_name: this.user.accountName,
      account_mobilephone: this.user.accountMobilephone,
      account_email: this.user.accountEmail
    };
  },
  methods: {
    async save() {
      this.clearError();
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        await this.updateProfile(this.form);
      }
    }
  }
};
</script>
